/*
 * TC 큐레이션 소팅탭
 * .tc-sort-btn 클릭 시, 같은 인덱스의 .tc-sec--cont 만 .is-active (보이기).
 */
(function () {
  function init(sec) {
    if (sec.dataset.curationInit === '1') return;
    sec.dataset.curationInit = '1';

    var btns = Array.prototype.slice.call(sec.querySelectorAll('.tc-sort-btn'));
    var conts = Array.prototype.slice.call(sec.querySelectorAll('.tc-sec--cont'));

    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        conts.forEach(function (c) { c.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (conts[i]) conts[i].classList.add('is-active');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.tc-sec--curation').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // 테마 에디터: 섹션 다시 그릴 때 재초기화
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.tc-sec--curation') : null;
    if (el) {
      el.dataset.curationInit = '';
      init(el);
    } else {
      initAll();
    }
  });
})();
